import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { NewsList } from './NewsList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { NewsRelease, NewsReleaseTag } from '@/types/newsRelease'

type ReleasePageProps = {
  newsRelease: NewsRelease[]
  tagList: readonly NewsReleaseTag[]
}

export const ReleasePage = ({ newsRelease, tagList }: ReleasePageProps) => {
  const router = useRouter()
  const tag = router.query.tag
  const initialTag = typeof tag === 'string' ? tag : undefined

  return (
    <Wrapper>
      <SectionTitle
        titleText="News Release"
        subTitleText="ニュースリリース"
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 50 }} />
      <NewsList
        newsRelease={newsRelease}
        tagList={tagList}
        initialTag={initialTag}
      />
    </Wrapper>
  )
}

ReleasePage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: 'ニュースリリース', path: '' },
  ]

  return (
    <>
      <Head
        title="ニュースリリース"
        description="プレスリリースや各種取り組みを紹介するお知らせなど、トライアルホールディングスの最新情報を掲載しています。"
        ogp={{ url: 'news/release/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const Wrapper = styled.div`
  width: 1045px;
  margin: 0 auto;
  padding: 70px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
  }
`
